import React, { FC } from 'react';

type WorldProps = {
  /** The color of the icon. */
  color?: string;
};

const World: FC<WorldProps> = ({ color = 'white' }) => (
  <svg fill="none" height="100%" viewBox="0 0 24 24" width="100%" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
    <path d="M2 12H22" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.25" />
    <path d="M10.5391 2.5C8.8724 5 6.03907 12.7 10.0391 21.5" stroke={color} strokeWidth="1.25" />
    <path d="M14 2.5C15.6667 5 18.5 12.7 14.5 21.5" stroke={color} strokeWidth="1.25" />
    <path d="M21.7695 9.26953C19.2695 7.60286 11.5695 4.76954 2.76953 8.76954" stroke={color} strokeWidth="1.25" />
    <path d="M2.76953 14.7305C5.26953 16.3971 12.9695 19.2305 21.7695 15.2305" stroke={color} strokeWidth="1.25" />
  </svg>

);

export default World;
